import api from './index';

export const AuthAPI = {
  getCustomToken: (tokenId): Promise<{ token: string }> => api.post('/auth/custom-token', { tokenId }),
  generateCustomToken: (): Promise<{ token: string }> => api.post('/auth/generate-custom-token'),
  signOut: (): Promise<any> => api.post('/auth/sign-out')

};
